/**
 * Collapsible second-driver sub-section for `ManualBookingDialog`. Optional —
 * if `secondDriver` is `null`, only the toggle button is shown; once added,
 * the parent submit gates on name + licence being filled.
 */
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { UserPlus } from "lucide-react";

const EMPTY_DRIVER = { full_name: "", license_number: "", phone: "" };

export function ManualBookingSecondDriverPanel({ secondDriver, setSecondDriver }) {
  return (
    <div className="rounded-xl border border-border p-3" data-testid="manual-booking-second-driver-section">
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-wider text-neutral-500 font-semibold flex items-center gap-1.5">
          <UserPlus className="h-3.5 w-3.5" />Second driver
        </div>
        <Button
          type="button" size="sm" variant="ghost"
          onClick={() => setSecondDriver(secondDriver ? null : { ...EMPTY_DRIVER })}
          className="rounded-full text-xs"
          data-testid="manual-booking-second-driver-toggle"
        >
          {secondDriver ? "Remove" : "Add second driver"}
        </Button>
      </div>
      {secondDriver && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-2">
          <div>
            <Label>Full name</Label>
            <Input
              value={secondDriver.full_name}
              onChange={(e) => setSecondDriver({ ...secondDriver, full_name: e.target.value })}
              className="mt-1 rounded-xl"
              data-testid="manual-second-driver-name"
            />
          </div>
          <div>
            <Label>Licence number</Label>
            <Input
              value={secondDriver.license_number}
              onChange={(e) => setSecondDriver({ ...secondDriver, license_number: e.target.value })}
              className="mt-1 rounded-xl"
              data-testid="manual-second-driver-licence"
            />
          </div>
          <div>
            <Label>Phone (optional)</Label>
            <Input
              value={secondDriver.phone}
              onChange={(e) => setSecondDriver({ ...secondDriver, phone: e.target.value })}
              className="mt-1 rounded-xl"
              data-testid="manual-second-driver-phone"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ManualBookingSecondDriverPanel;
